import { useEffect, useState, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import EFVideoModal from '@/components/UI/EFVideoModal';
import NextImage from '@/components/NextImage';

export default function D() {
    const { useLang, gtm, useRouter, useRef } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    // const timer = useRef(null);
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState();
    const NA_SITES = ['us', 'ca'];

    const sceneList =
        locale === 'cn'
            ? [
                  {
                      idx: 1,
                      name: 'teaser.sectionD_scene3',
                      video: ['/video/wave2/pc/section_d_tents.webm', '/video/wave2/pc/section_d_tents.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_tents.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_tents.jpg'),
                  },
                  {
                      idx: 2,
                      name: 'teaser.sectionD_scene2',
                      video: ['/video/wave2/pc/section_d_outdoors.webm', '/video/wave2/pc/section_d_outdoors.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_outdoors.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_outdoors.jpg'),
                  },
                  {
                      idx: 3,
                      name: 'teaser.sectionD_scene1',
                      video: ['/video/wave2/pc/section_d_rv.webm', '/video/wave2/pc/section_d_rv.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_rv.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_rv.jpg'),
                  },
                  {
                      idx: 4,
                      name: 'teaser.sectionD_scene5',
                      video: ['/video/wave2/pc/section_d_boats.webm', '/video/wave2/pc/section_d_boats.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_boats.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_boats.jpg'),
                  },
              ]
            : NA_SITES.includes(locale)
            ? [
                  {
                      idx: 1,
                      name: 'detail.sectionD_scene1',
                      video: ['/video/wave2/pc/section_d_rv.webm', '/video/wave2/pc/section_d_rv.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_RVs.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_RVs.jpg`),
                  },
                  {
                      idx: 2,
                      name: 'detail.sectionD_scene2',
                      video: ['/video/wave2/pc/section_d_truvks.webm', '/video/wave2/pc/section_d_truvks.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_Cars.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_Cars.jpg`),
                  },
                  {
                      idx: 3,
                      name: 'detail.sectionD_scene3',
                      video: ['/video/wave2/pc/section_d_off_grid.webm', '/video/wave2/pc/section_d_off_grid.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_Tents.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_Tents.jpg`),
                  },
                  {
                      idx: 4,
                      name: 'detail.sectionD_scene4',
                      video: ['/video/wave2/pc/section_d_outdoors.webm', '/video/wave2/pc/section_d_outdoors.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_Outdoors.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_Outdoors.jpg`),
                  },
                  {
                      idx: 5,
                      name: 'detail.sectionD_scene5',
                      video: ['/video/wave2/pc/section_d_tents.webm', '/video/wave2/pc/section_d_tents.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_Indoors.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_Indoors.jpg`),
                  },
                  {
                      idx: 6,
                      name: 'detail.sectionD_scene6',
                      video: ['/video/wave2/pc/section_d_boats.webm', '/video/wave2/pc/section_d_boats.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/4_Boats.jpg`),
                      src: require(`@publicLocal/wave2/detail/pc/4_Boats.jpg`),
                  },
              ]
            : [
                  {
                      idx: 1,
                      name: 'teaser.sectionD_scene1',
                      video: ['/video/wave2/pc/section_d_rv.webm', '/video/wave2/pc/section_d_rv.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/d_rv${locale === 'au' ? '_au' : ''}.webp`),
                      src: require(`@publicLocal/wave2/detail/pc/d_rv${locale === 'au' ? '_au' : ''}.jpg`),
                  },
                  {
                      idx: 2,
                      name: 'teaser.sectionD_scene4',
                      video: ['/video/wave2/pc/section_d_truvks.webm', '/video/wave2/pc/section_d_truvks.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_trucks.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_trucks.jpg'),
                  },
                  {
                      idx: 3,
                      name: 'teaser.sectionD_scene6',
                      video: ['/video/wave2/pc/section_d_off_grid.webm', '/video/wave2/pc/section_d_off_grid.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_grid.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_grid.jpg'),
                  },
                  {
                      idx: 4,
                      name: 'teaser.sectionD_scene2',
                      video: ['/video/wave2/pc/section_d_outdoors.webm', '/video/wave2/pc/section_d_outdoors.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/d_outdoors${locale === 'au' ? '_au' : ''}.webp`),
                      src: require(`@publicLocal/wave2/detail/pc/d_outdoors${locale === 'au' ? '_au' : ''}.jpg`),
                  },
                  {
                      idx: 5,
                      name: 'teaser.sectionD_scene3',
                      video: ['/video/wave2/pc/section_d_tents.webm', '/video/wave2/pc/section_d_tents.mp4'],
                      webpSrc: require(`@publicLocal/wave2/detail/pc/d_tents${locale === 'au' ? '_au' : ''}.webp`),
                      src: require(`@publicLocal/wave2/detail/pc/d_tents${locale === 'au' ? '_au' : ''}.jpg`),
                  },
                  {
                      idx: 6,
                      name: 'teaser.sectionD_scene5',
                      video: ['/video/wave2/pc/section_d_boats.webm', '/video/wave2/pc/section_d_boats.mp4'],
                      webpSrc: require('@publicLocal/wave2/detail/pc/d_boats.webp'),
                      src: require('@publicLocal/wave2/detail/pc/d_boats.jpg'),
                  },
              ];

    const [scene, setScene] = useState(sceneList[0]);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/9gih1uHbnRA',
        de: 'https://www.youtube.com/embed/RgJe0DUmt3s',
        fr: 'https://www.youtube.com/embed/0Xh7J-ghvXc',
        it: 'https://www.youtube.com/embed/dd9JNXPwBfM',
        es: 'https://www.youtube.com/embed/iQefI6QzBn0',
        jp: 'https://www.youtube.com/embed/EO7iBR2OVFM',
        // kr: 'https://www.youtube.com/embed/5eGN9KRd5GM',
        kr: 'https://www.youtube.com/embed/NXXAkF6ht0I',

        cn: {
            SD: 'https://videos.ecoflow.com/dae8e250e03471ed80217630a6ac0102/d15f364d746f36624a5154407fc77315-ld.mp4',
            HD: 'https://videos.ecoflow.com/dae8e250e03471ed80217630a6ac0102/1c171c8a794aeaed56827632edfd510d-sd.mp4',
            '2K': 'https://videos.ecoflow.com/dae8e250e03471ed80217630a6ac0102/7978d5ddee63018675a9aee2548904fe-hd.mp4',
        },
    };

    const playerVideo = (text: string) => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: ['us', 'ca'].includes(locale) ? t('detail.sectionD_title') : t('wave2slogan'),
            position: `Product Detail_${['us', 'ca'].includes(locale) ? '5' : '2'}`,
        });
    };

    const clickTab = (i: number) => {
        // clearTimeout(timer.current);
        // timer.current = null;
        setActive(i);
        setScene(sceneList[i]);
        swiper.slideTo(i);
    };

    const onSlideChangeFn = useCallback((swiper: any) => {
        setActive(swiper?.activeIndex);
        setScene(sceneList[swiper?.activeIndex % sceneList?.length]);
    }, []);

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [[`.${css.wave2DetailD} .viewport-wrapper`, { opacity: 0 }, { opacity: 1 }]],
            triggerElement: `.${css.wave2DetailD} .viewport-wrapper`,
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
    }, []);

    // useEffect(() => {
    //     console.log('aa');
    //     timer.current = setTimeout(() => {
    //         if (scene.idx === sceneList.length) {
    //             setActive(0);
    //             setScene(sceneList[0]);
    //         } else {
    //             setActive(active + 1);
    //             setScene(sceneList[scene.idx]);
    //         }
    //     }, 2000);
    // }, [scene, timer]);

    return (
        <div className={`wave2-detail-D ${css.wave2DetailD}`}>
            <div className="viewport-wrapper">
                {!NA_SITES.includes(locale) && <p className="title">{t('wave2slogan')}</p>}
                {NA_SITES.includes(locale) && <p className="title">{t('detail.sectionD_title')}</p>}
                <p className="video-btn" onClick={() => playerVideo('EcoFlow WAVE2 use scene')}>
                    <span className="text">{t('detail.video_btn')}</span>
                    <span className="btn-1">
                        <EFDelta2VideoPlayer fillColor="#2673ff" />
                    </span>
                    <span className="btn-2">
                        <EFDelta2VideoPlayer />
                    </span>
                </p>
                <div className="video-list">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={true}
                        slidesPerView={'auto'}
                        spaceBetween={0}
                        preloadImages={false}
                        lazy={true}
                        centeredSlides={true}
                        grabCursor={true}
                        loop={true}
                        onSlideChange={(swiper: any) => onSlideChangeFn(swiper)}
                        speed={800}
                        onSwiper={(swiper: any) => setSwiper(swiper)}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                    >
                        {sceneList.map((item: any) => (
                            <SwiperSlide key={item.idx}>
                                <div className="video-box">
                                    {/* <EFVideo className="video-box-self" sources={item.src} width="100%" loop={false} showReplay endFrame={0} /> */}
                                    {/* 测试要求循环播放 */}
                                    {/* <EFVideo className="video-box-self" sources={item.src} width="100%" /> */}
                                    <NextImage webpSrc={item.webpSrc} src={item.src} alt={t(item.name)} aria-label={t(item.name)} />
                                </div>
                                <div className="video-name">{t(item.name)}</div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="scene-list">
                    {sceneList.map((item, i) => (
                        <span key={i} className={`scene ${scene.name === item.name ? 'active' : ''}`} onClick={() => clickTab(i)}>
                            {t(item.name)}
                        </span>
                    ))}
                </div>
                <EFVideoModal
                    visible={showEFVideoModal}
                    source={videoSourceMap[locale] || videoSourceMap.us}
                    onClose={() => setShowEFVideoModal(false)}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            </div>
        </div>
    );
}
